// Libs
import React, { useContext, useEffect, useState } from 'react';
import * as Yup from 'yup';

// Own Libs
import * as ui from '@digital/ui';

//Api

//Files
import QuestionarioContextProvider from '../../../../../hooks/useQuestionario';
import CurrencyInput from '@app/components/CurrencyInput';

//Utils
import {optionsSwitch} from '@app/helpers/optionsSwitch';
import { EStatusDemanda } from '@app/enums/EStatusDemanda';


function DadosQuantitativosStep() {
  const [tipoDespesa, setTipoDespesa] = useState('');

  const {
    statusCodigo,
    demandaData,
    capex,
    setCapex,
    opex,
    setOpex,
    contaResultado,
    setContaResultado,
  } = useContext(QuestionarioContextProvider);

  useEffect(() => {
    if (capex) {
      setTipoDespesa('capex');
    } else if (opex) {
      setTipoDespesa('opex');
    } else if (contaResultado) {
      setTipoDespesa('resultado');
    }
  }, [demandaData, capex, opex, contaResultado]);

  const handleSelectDespesa = e => {
    if (e === 'capex') {
      setCapex(true);
      setOpex(false);
      setContaResultado(false);
    }
    if (e === 'opex') {
      setOpex(true);
      setCapex(false);
      setContaResultado(false);
    }
    if (e === 'resultado') {
      setContaResultado(true);
      setCapex(false);
      setOpex(false);
    }
  };

  return (
    <>

      <ui.Row>
        <CurrencyInput
          id='mrn-input-expectativaValorFinal'
          label="Valor Total de Contratação"
          name="expectativaValorFinal"
          span={6}
          required
          disabled={[
            EStatusDemanda.Cancelada,
            EStatusDemanda.AguardandoAnaliseControleFinanceiro,
            EStatusDemanda.AguardandoAnaliseControladoria,
            EStatusDemanda.AguardandoAnalisePreSuprimentos,
            EStatusDemanda.OnHoldDemandante,
          ].includes(statusCodigo || 0)
          }
        />
        <ui.FormNumber
          id='mrn-input-expectativaDePrazo'
          label="Prazo (em meses)"
          name="expectativaDePrazo"
          span={6}
          disabled={[
            EStatusDemanda.Cancelada,
            EStatusDemanda.AguardandoAnaliseControleFinanceiro,
            EStatusDemanda.AguardandoAnaliseControladoria,
            EStatusDemanda.AguardandoAnalisePreSuprimentos,
            EStatusDemanda.OnHoldDemandante,
          ].includes(statusCodigo || 0)
          }
          validateSchema={Yup.number()
            .transform(value => (isNaN(value) ? undefined : value))
            .required('Campo requerido.')}
        />
      </ui.Row>

      <ui.Row>
        <ui.FormSelect
          id='mrn-select-tipoDespesa'
          label="Tipo de Despesa"
          span={4}
          value={tipoDespesa}
          name="tipoDespesa"
          onSelect={e => handleSelectDespesa(e)}
          options={[
            { text: 'CAPEX', value: 'capex' },
            { text: 'OPEX', value: 'opex' },
            { text: 'Conta de Resultado', value: 'resultado' },
          ]}
          disabled={[
            EStatusDemanda.Cancelada,
            EStatusDemanda.AguardandoAnaliseControleFinanceiro,
            EStatusDemanda.AguardandoAnaliseControladoria,
            EStatusDemanda.AguardandoAnalisePreSuprimentos,
            EStatusDemanda.OnHoldDemandante,
          ].includes(statusCodigo || 0)
          }
          required={tipoDespesa === '' || tipoDespesa === undefined}
        />

        <ui.FormSelect
          id='mrn-select-haveraDespesasReembolsaveis'
          options={optionsSwitch}
          label="Haverá Despesas Reembolsáveis?"
          name="haveraDespesasReembolsaveis"
          span={4}
          required
          disabled={[
            EStatusDemanda.Cancelada,
            EStatusDemanda.AguardandoAnaliseControleFinanceiro,
            EStatusDemanda.AguardandoAnaliseControladoria,
            EStatusDemanda.AguardandoAnalisePreSuprimentos,
            EStatusDemanda.OnHoldDemandante,
          ].includes(statusCodigo || 0)
          }
        />
      </ui.Row>

    </>
  );

}

export default DadosQuantitativosStep;
